import { Box, LinearProgress, Paper, Skeleton, Typography } from '@mui/material';

import { useProfileFillRate } from 'entities/analytics/model';

const Stat = ({ label, perAccount, total }: { label: string; perAccount: number; total: number }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h5" fontWeight={600} lineHeight={1.2}>
      {perAccount.toFixed(2)}
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
      avg per account
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
      {total.toLocaleString()} total
    </Typography>
  </Box>
);

export const FillRateCard = () => {
  const { data, isLoading } = useProfileFillRate();
  const d = data?.data;
  const rate = d && d.accounts > 0 ? Math.round((d.accountsWithData / d.accounts) * 100) : 0;

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle1" fontWeight={500}>
        Profile fill-rate
      </Typography>
      <Typography variant="caption" color="text.secondary">
        How much an average account holds. Big number = average per account; below it = total across all{' '}
        {(d?.accounts ?? 0).toLocaleString()} accounts.
      </Typography>

      {isLoading ? (
        <Skeleton variant="rectangular" height={110} sx={{ mt: 1.5, borderRadius: 1 }} />
      ) : (
        <>
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' }, mt: 1.5 }}>
            <Stat label="People" perAccount={d?.people?.perAccount ?? 0} total={d?.people?.total ?? 0} />
            <Stat label="Pets" perAccount={d?.pets?.perAccount ?? 0} total={d?.pets?.total ?? 0} />
            <Stat
              label="Vaccinations"
              perAccount={d?.vaccinations?.perAccount ?? 0}
              total={d?.vaccinations?.total ?? 0}
            />
            <Stat label="Documents" perAccount={d?.documents?.perAccount ?? 0} total={d?.documents?.total ?? 0} />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 0.5, gap: 1 }}>
              <Typography variant="caption" color="text.secondary">
                Activation rate — accounts with at least one person or pet (i.e. not empty)
              </Typography>
              <Typography variant="caption" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
                {rate}% · {(d?.accountsWithData ?? 0).toLocaleString()} of {(d?.accounts ?? 0).toLocaleString()}
              </Typography>
            </Box>
            <LinearProgress variant="determinate" value={rate} sx={{ height: 8, borderRadius: 4 }} />
          </Box>
        </>
      )}
    </Paper>
  );
};
